/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section3_Li3Inputs */

const en_about_section3_li3 = /** @type {(inputs: About_Section3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Minifier: Compress JSON by removing whitespace to reduce file size`)
};

const ko_about_section3_li3 = /** @type {(inputs: About_Section3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 압축기: 공백을 제거하여 JSON을 압축하고 파일 크기 축소`)
};

const ja_about_section3_li3 = /** @type {(inputs: About_Section3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON圧縮ツール: 空白を削除してJSONを圧縮しファイルサイズを削減`)
};

/**
* | output |
* | --- |
* | "JSON Minifier: Compress JSON by removing whitespace to reduce file size" |
*
* @param {About_Section3_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section3_li3 = /** @type {((inputs?: About_Section3_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section3_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section3_li3(inputs)
	if (locale === "ko") return ko_about_section3_li3(inputs)
	return ja_about_section3_li3(inputs)
});